<template>
    <div>
        <div v-if="!initialized && busy"><i class="icon-spinner2 spinner"></i></div>
        <div v-else>
            <div class="card">
                <div class="card-header bg-white header-elements-inline">
                    <h5 class="card-title">Bilder</h5>
                    <div class="header-elements">
                        <button type="button" class="btn btn-light mr-2" @click="showBrowseModal('images')">
                            Bläddra
                        </button>
<!--                        <button type="button" class="btn btn-light" @click="showUploadModal()">-->
<!--                            Ladda upp media-->
<!--                        </button>-->
                    </div>
                </div>
                <div class="">
                    <table class="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th class="text-center">Miniatyr</th>
                                <th>Filnamn</th>
                                <th class="text-center">Visas på webben</th>
                                <th></th>
                            </tr>
                        </thead>
                        <draggable v-model="images" handle=".drag" tag="tbody" v-if="images">
                            <tr v-for="(image, i_index) in images" :key="'f-' + i_index">
                                <td class="drag pr-0 text-center" style="width: 45px; cursor: pointer;">
                                    <i class="icon icon-arrow-resize8"></i>
                                </td>
                                <td style="width: 200px;">
                                    <div
                                        class="image-wrapper"
                                        :style="{ 'background-image': 'url(' + image.internal_urls.small + ')' }"
                                        @click="previewImage(image)"
                                        style="cursor: pointer;"
                                    ></div>
                                </td>
                                <td>{{ image.filename }}</td>
                                <td class="text-center" style="width: 160px;">
                                    <div class="custom-control custom-switch d-inline-flex">
                                        <input
                                            :id="'show-on-web-' + image.image_id"
                                            v-model="image.show_on_web"
                                            type="checkbox"
                                            class="custom-control-input"
                                        >
                                        <label class="custom-control-label" :for="'show-on-web-' + image.image_id"></label>
                                    </div>
                                </td>
                                <td class="text-right">
                                    <a :href="image.internal_urls.original" class="btn btn-outline-primary" download>
                                        <i class="icon-download4 mr-1"></i>Ladda ner
                                    </a>
                                    <button type="button" class="btn btn-danger" @click="removeImage(i_index)">
                                        <i class="icon-trash mr-1"></i>Ta bort
                                    </button>
                                </td>
                            </tr>
                        </draggable>
                    </table>
                </div>
            </div>

            <div class="d-flex justify-content-end">
                <limitless-button ref="btnsaveimages" type="button" @click="saveImages" :busy="busy" icon="icon-floppy-disk">SPARA</limitless-button>
            </div>
        </div>

        <b-modal
            id="modal_browse_images"
            title="Bläddra bland bilder"
            key="modal_browse_images"
            ok-only
            scrollable
            ok-title="Stäng"
            ok-variant="light"
            size="xl"
        >
            <mediabank-browser
                :selected="selected_image_ids"
                :category-id="1014"
                @select="addImage"
                @deselect="deselectImage"
                upload
                modal
            />
        </b-modal>

        <b-modal
            id="modal_preview_image"
            title="Preview"
            key="modal_preview_image"
            ok-only ok-title="Stäng"
            size="xl"
            @ok="closePreviewImageModal"
            @cancel="closePreviewImageModal"
            @close="closePreviewImageModal"
            @hide="closePreviewImageModal"
        >
            <div v-if="preview_image" class="d-flex justify-content-center align-items-center" style="width: 100%;">
                <div style="border: 1px solid #ccc;">
                    <img :src="preview_image.internal_urls.original" alt="preview" style="max-width: 100%;">
                </div>
            </div>
            <template #modal-footer="{ hide }">
                <a v-if="preview_image" :href="preview_image.internal_urls.original" class="btn btn-outline-primary mr-auto" download>
                    <i class="icon-download4 mr-1"></i> Ladda ner
                </a>
                <button type="button" class="btn btn-light" @click="hide">Stäng</button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import { formatDateTime } from '@services/Helpers';
import MediabankBrowser from '@components/MediabankBrowser.vue';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import draggable from 'vuedraggable';

export default {
    name: 'ProductEditorImages',
    components: {
        MediabankBrowser,
        LimitlessButton,
        draggable,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    created() {
        this.getImages();
    },
    data: () => ({
        initialized: false,
        busy: true,
        images: [],
        preview_image: null,
    }),
    methods: {
        formatDateTime,
        async getImages() {
            await apiClient.get('/vue/products/' + this.id + '/images')
                .then((response) => {
                    if (response.data) {
                        this.images = response.data.images;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy = false;
                });
        },
        async saveImages() {
            this.busy = true;
            await apiClient.post('/vue/products/' + this.id + '/images', { images: this.images })
                .then((response) => {
                    if (response.data) {
                        this.images = response.data.images;
                    }
                    this.$refs.btnsaveimages.triggerSaved();
                })
                .catch(() => {
                    this.$refs.btnsaveimages.triggerFailed();
                })
                .finally(() => {
                    this.busy = false;
                });
        },
        showBrowseModal() {
            this.$root.$bvModal.show('modal_browse_images');
        },
        addImage(image) {
            if (!this.images || !Array.isArray(this.images)) {
                this.images = [];
            }
            this.images.push({ ...image, show_on_web: true });
        },
        deselectImage(image) {
            const index = this.images.findIndex((i) => i.image_id === image.image_id);
            this.removeImage(index);
        },
        removeImage(index) {
            this.images.splice(index, 1);
        },
        previewImage(image) {
            this.preview_image = image;
            this.$root.$bvModal.show('modal_preview_image');
        },
        closePreviewImageModal() {
            this.preview_image = null;
        },
    },
    computed: {
        selected_image_ids() {
            const arr = [];
            if (this.images) {
                this.images.forEach((image) => {
                    arr.push(image.image_id);
                });
            }
            return arr;
        },
    },
};
</script>

<style scoped lang="scss">
.sortable-ghost {
    border: 1px dashed #aaa;
    position: relative;
    box-shadow: none;
    -webkit-box-shadow: none;
}

.sortable-ghost:before {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #ffffff;
    z-index: 10;
    padding: 5px;
}

.image-wrapper {
    position: relative;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

.image-wrapper div {
    background-color: #eeeeee;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.image-wrapper:after {
    content: '';
    width: 100%;
    padding-bottom: 75%;
    display: block;
}
</style>
